import { spacing, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-background-box";
const white = objectWithClassName({
  className: `${classNamePrefix}-white`,
  display: "inline-block",
  zIndex: "9",
  backgroundColor: `${color.white}`,
  padding: `${spacing.sm} ${spacing.sm} ${spacing.min} ${spacing.sm}`
});
export {
  white
};
//# sourceMappingURL=box.js.map
